import { useMemo } from 'react';
import { Button } from '@/features/button';
import { NavigationCarousel } from '@/features/carousel';
import { IconTrash } from '@/features/icons';
import { EasyAccess } from '@/features/tag';
import { cn } from '@/utils/cn';
import CategoryFilter from './category-filter';
import { useVideosFilterContext } from '../context';
const LabelsFilter = () => {
  const {
    activeLabels,
    activeCategories,
    toggleLabel,
    isLabelsLoading,
    labels,
    toggleCategory,
    clearAllFilters
  } = useVideosFilterContext();
  const sortedLabels = useMemo(() => labels.slice().sort((a, b) => {
    const aIsActive = activeLabels.includes(a);
    const bIsActive = activeLabels.includes(b);
    if (aIsActive && !bIsActive) return -1;
    if (!aIsActive && bIsActive) return 1;
    return 0;
  }), [activeLabels, labels]);
  if (isLabelsLoading) {
    return <div className='hide-scrollbar mb-4 flex gap-1 overflow-hidden lg:mb-6'>
                {Array.from({
        length: 10
      }).map((_, index) => <div key={index} className='h-7.5 w-24 shrink-0 animate-pulse rounded bg-gray-100' />)}
            </div>;
  }
  const activeCategory = activeCategories.at(0);
  const hasActiveFilters = activeLabels.length > 0 || !!activeCategory;
  return <div className='mb-4 flex pt-2 lg:mb-6 lg:pt-4' data-sentry-component="LabelsFilter" data-sentry-source-file="labels-filter.tsx">
            <CategoryFilter mode='mobile' data-sentry-element="CategoryFilter" data-sentry-source-file="labels-filter.tsx" />

            {hasActiveFilters && <div className='hidden shrink-0 items-center gap-1 lg:flex'>
                    <Button size='xsmall' graphicStyle='text' onClick={clearAllFilters} className='lg:text-caption-12' icon={{
        position: 'right',
        element: <IconTrash className='h-5 w-5' />
      }}>
                        حذف فیلتر ها
                    </Button>

                    {!!activeCategory && <EasyAccess size='medium' className='relative ml-2 after:absolute after:-left-[7px] after:mr-px after:inline-block after:h-full after:w-px after:bg-border-gray-medium after:content-[""]' onClick={() => activeCategory.id?.value && toggleCategory(activeCategory.id.value)}>
                            {activeCategory.title}
                        </EasyAccess>}
                </div>}

            <NavigationCarousel className={cn('!w-[calc(100vw_-_114px)] pr-1', {
      'lg:!w-[calc(100%_-_187px)]': hasActiveFilters && !!activeCategory,
      'lg:!w-[calc(100%_-_110px)]': hasActiveFilters && !activeCategory
    })} options={{
      perView: 'auto',
      spacing: 4,
      mode: 'free'
    }} data-sentry-element="NavigationCarousel" data-sentry-source-file="labels-filter.tsx">
                {sortedLabels.map(label => {
        const isActive = activeLabels.includes(label);
        return <EasyAccess key={label} size='medium' className='keen-slider__slide !w-fit min-w-fit justify-center' onClick={() => toggleLabel(label)} isActive={isActive} showClose={false}>
                            {label}
                        </EasyAccess>;
      })}
            </NavigationCarousel>
        </div>;
};
export default LabelsFilter;